import axios from 'axios';

const locale = document.documentElement.lang || 'en'; // read lang attribute from <html> element or set the fallback locale
const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';

export const apiClient = axios.create({
  headers: {
    locale: locale,
    'X-CSRF-TOKEN': csrf,
  },
});

interface ApiEnumParams {
  existing?: 0 | 1;
}

/**
 * This method is used for fetching enumerable entities from API
 */
export function apiFetchEnum(entity: string, params: ApiEnumParams = {}): Promise<object | string> {
  return new Promise((resolve, reject) => {
    apiClient
      .get(`/api/resource/${entity}`, { params })
      .then(response => {
        const entityName = pluralizeName(entity);

        if (response.data && response.data[entityName]) {
          resolve(response.data[entityName].data);
        }
        reject('No data');
      })
      .catch(e => {
        reject(e);
      })
  });
}

function pluralizeName(name: string): string {
  if (name.substr(name.length - 1, 1) === 'y') {
    return name.substr(0, name.length - 1) + 'ies'; // company => companies
  }

  if (name.substr(name.length - 1, 1) === 's') {
    return name + 'es'; // status => statuses
  }

  return name + 's'; // vehicle => vehicles
}
